import { makeRESTApiRequests } from "../helpers/api";
import { ENDPOINTS } from "../helpers/constants";

export const authService = {
  signIn: (email, password) =>
    makeRESTApiRequests({
      endpoint: ENDPOINTS.LOGIN,
      requestBody: { email, password },
    }),

  register: (formData) =>
    makeRESTApiRequests({
      endpoint: ENDPOINTS.REGISTER,
      requestBody: formData,
    }),

  getMe: () =>
    makeRESTApiRequests({
      endpoint: ENDPOINTS.GET_ME,
      method: "GET",
    }),

  signOut: () =>
    makeRESTApiRequests({
      endpoint: ENDPOINTS.LOGOUT,
      method: "POST",
    }),

  generateRegistrationOTP: (email) =>
    makeRESTApiRequests({
      endpoint: ENDPOINTS.GENERATE_REGISTRATION_OTP,
      requestBody: { email },
    }),

  forgotPassword: (email) =>
    makeRESTApiRequests({
      endpoint: ENDPOINTS.FORGOT_PASSWORD,
      requestBody: { email },
    }),

  resetPassword: (formData) =>
    makeRESTApiRequests({
      endpoint: ENDPOINTS.RESET_PASSWORD,
      requestBody: formData,
    }),
};
